module.exports = __webpack_public_path__ + "static/media/RRD3.5901fc9f.jpg";